export var IPayoutTermEnum;
(function (IPayoutTermEnum) {
    let PayoutTerm;
    (function (PayoutTerm) {
        PayoutTerm["UNSPECIFIED"] = "UNSPECIFIED";
        PayoutTerm["CREDIT_CARD"] = "CREDIT_CARD";
        PayoutTerm["ACH_NEXT_DAY"] = "ACH_NEXT_DAY";
        PayoutTerm["ACH_NET30"] = "ACH_NET30";
        /**
         * Applied to brand orders that are eligible for upfront payments on brands that currently have ACH_NEXT_DAY
         * as their payout term. Shouldn't be set as the default on brands
         */
        PayoutTerm["ACH_NEXT_DAY_WITH_UPFRONT"] = "ACH_NEXT_DAY_WITH_UPFRONT";
        /**
         * Applied to brand orders that are eligible for upfront payments on brands that currently have ACH_NET30
         * as their payout term. Shouldn't be set as the default on brands
         */
        PayoutTerm["ACH_NET30_WITH_UPFRONT"] = "ACH_NET30_WITH_UPFRONT";
        PayoutTerm["ACH_NET60"] = "ACH_NET60";
    })(PayoutTerm = IPayoutTermEnum.PayoutTerm || (IPayoutTermEnum.PayoutTerm = {}));
    /**
     * Return an instance of IPayoutTermEnum with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IPayoutTermEnum.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IPayoutTermEnum || (IPayoutTermEnum = {}));
